// The test environment (built for staging-api.svenex.app) says so on every
// screen: a line across the top, a STAGING badge and [STAGING] in the tab
// title, so it can't be mistaken for the real SVENEX. Plain DOM, outside
// React, so it shows on the sign-in page and on error screens too.
export const STAGING = import.meta.env.VITE_SVENEX_ENV === "staging";

if (STAGING) {
  const mark = () => {
    if (!document.title.startsWith("[STAGING]")) document.title = "[STAGING] " + document.title;
  };
  mark();
  new MutationObserver(mark).observe(document.querySelector("title") ?? document.head, { childList: true, subtree: true, characterData: true });
  document.documentElement.classList.add("is-staging");
  const badge = document.createElement("div");
  badge.className = "staging-badge";
  badge.setAttribute("role", "note");
  badge.title = "This is the SVENEX test environment. Nothing here is real.";
  badge.textContent = "STAGING · test environment";
  document.body.appendChild(badge);
}
